module.exports = __webpack_public_path__ + "fonts/Inter-200-vietnamese15.74fe938.woff2";